/* eslint-disable parog-web/no-glint-expect-error-directive */
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { PracticeLocation } from 'parog-web/cnam/types';
import type InsWithConfirmationRetrievalContext from 'parog-web/contexts/ins-with-confirmation-retrieval-context';
import Button from 'ui-kit/components/button';
import fuiDropdown from 'wise-fui-modules/modifiers/fui-dropdown';

interface Args {
  context: InsWithConfirmationRetrievalContext;
}

export default class InsRetrieveAccessFormSetPracticeLocationWithBillingNumberComponent extends Component<Args> {
  @tracked selectedPracticeLocationIndex = 0;
  @tracked tempPracticeLocation?: string =
    this.args.context.authenticationContext
      .practiceLocationsWithValidBillingNumber![0].structureName;

  get practiceLocationsWithValidBillingNumber(): PracticeLocation[] {
    return this.args.context.authenticationContext
      .practiceLocationsWithValidBillingNumber!;
  }

  onSubmit = async (event: Event): Promise<void> => {
    event.preventDefault();
    this.args.context.practiceLocation = this.tempPracticeLocation as string;
    this.tempPracticeLocation = undefined;
    await this.args.context.transitionTo();
  };

  selectPracticeLocation = (newIndex: number): void => {
    this.selectedPracticeLocationIndex = newIndex;
    this.tempPracticeLocation =
      this.practiceLocationsWithValidBillingNumber[newIndex].structureName;
  };

  <template>
    <div data-test-practice-locations-state>
      <form
        {{on 'submit' this.onSubmit}}
        class='ui form'
        id='dmp-access-form-practice-location-selection-state-form'
      >

        <div class='field'>
          <label class='ui small header'>Sélectionnez une situation d'exercice
            avec des informations de facturation</label>
          <p>La situation d'exercice "{{@context.authenticationContext.practiceLocation}}"
            ne dispose pas d'informations de facturation, nécessaires à la
            récupération d'un INS.
            <br />
            Nous vous invitons donc à sélectionner une situation d'exercice
            disposant d'informations de facturation parmi celles présentes sur
            votre carte CPS.</p>
          {{! prettier-ignore }}
          <div
            class='ui dropdown selection'
            {{fuiDropdown onChange=this.selectPracticeLocation placeholder="Veuillez sélectionner une situation d'exercice" }}
            data-test-dropdown='practice-location'
          >
            <input type='hidden' value={{this.selectedPracticeLocationIndex}} />
            <div class='default text' data-test-select-placeholder>Situation
              d'exercice</div>
            <i class='dropdown icon'></i>
            <div class='menu'>
              {{#each
                this.practiceLocationsWithValidBillingNumber
                as |practiceLocation index|
              }}
                <div data-value={{index}} class='item'>
                  {{practiceLocation.structureName}}
                </div>
              {{/each}}
            </div>
          </div>
        </div>
        <p>Votre choix sera conservé pour les accès suivants. Vous pourrez
          toujours le modifier.</p>

        <div class='form-buttons'>

          <Button
            type='button'
            class='ui fluid form-button'
            {{! @glint-expect-error }}
            onclick={{@onDismiss}}
          >
            Annuler
          </Button>
          <Button
            data-test-button='submit-dmp-access-form'
            type='submit'
            class='ui fluid primary form-button
              {{unless this.tempPracticeLocation "disabled"}}'
          >
            Continuer
          </Button>
        </div>
      </form>
    </div>
  </template>
}
